<!--
 * @Author: ningbo.kang
 * @Date: 2019-09-26 10:16:53
 * @LastEditors: ningbo.kang
 * @LastEditTime: 2019-11-15 12:35:22
 * @FilePath: /template/src/components/tools/Breadcrumb.vue
 * @Description: 描述
 -->
<template>
  <a-breadcrumb class="breadcrumb">
    <a-breadcrumb-item v-for="(item, index) in breadList"
      :key="item.name">
      <router-link v-if="item.name != name && index != 1"
        :to="{ path: item.path === '' ? '/' : item.path }">{{ item.meta.title }}</router-link>
      <span v-else>{{ item.meta.title }}</span>
    </a-breadcrumb-item>
  </a-breadcrumb>
</template>

<script>
export default {
  name: 'e2-breadcrumb',
  data() {
    return {
      name: '',
      breadList: [],
    };
  },
  created() {
    this.getBreadcrumb();
  },
  methods: {
    getBreadcrumb() {
      this.breadList = [];
      // this.breadList.push({name: 'index', path: '/dashboard/', meta: {title: '首页'}})

      this.name = this.$route.name;
      this.$route.matched.forEach((item) => {
        // item.name !== 'index' && this.breadList.push(item)
        this.breadList.push(item);
      });
    },
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    },
  },
};
</script>

<style scoped>
</style>
